import { FileViewer, type FileSource } from '@powerportalspro/react-fluent';

const source: FileSource = {
  kind: 'url',
  value: 'https://placehold.co/600x400.png',
  fileName: 'placeholder.png',
};

export function FileViewerImageSample() {
  return <FileViewer source={source} maxHeight="400px" />;
}
